<template>
  <EmdPanel>
    <EmdPanelSection :title="$t('self-declared-legal-representative')">
      <EmdFormGroup :label="$t('self-declared-legal-representative')">
        <EmdSelect
          name="phone_type"
          v-model="selectedRepresentative"
        >
          <option
            v-for="(partner, index) in recipient.managing_partners"
            :key="index"
            :value="index"
          >
            {{
              partner.name ||
              $t('self-declared-legal-representative-placeholder', {
                number: index + 1
              })
            }}
          </option>
        </EmdSelect>
        <jade-checkbox
          id="input-checkbox"
          :value.sync="representativeCheckboxValue"
          :label="$t('confirmation-checkbox')"
          data-testid="input-checkbox"
          @change="setRepresentative"
        />
      </EmdFormGroup>
    </EmdPanelSection>
  </EmdPanel>
</template>

<script>
import {
  EmdFormGroup,
  EmdSelect,
  EmdPanel,
  EmdPanelSection
} from 'emerald-vue/src/components'
import { JadeCheckbox } from '@jade'
import { getState, feedbacks } from '@/utils/form.utils'
import { personalUser } from '../validations'
export default {
  name: 'SelfDeclaredLegalRepresentativeInput',
  components: {
    EmdFormGroup,
    EmdSelect,
    EmdPanel,
    EmdPanelSection,
    JadeCheckbox
  },
  data: () => ({
    getState,
    feedbacks,
    selectedRepresentative: 0,
    currentSelected: null,
    self_declared_legal_representative: '',
    representativeCheckboxValue: false
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    newSelected () {
      return this.recipient.managing_partners[this.selectedRepresentative]
    }
  },
  methods: {
    setRepresentative () {
      this.newSelected.self_declared_legal_representative =
        !this.newSelected.self_declared_legal_representative
      this.currentSelected = this.recipient.managing_partners.indexOf(
        this.newSelected
      )
    }
  },
  validations () {
    return { recipient: personalUser }
  },
  mounted () {
    const index = this.recipient.managing_partners.findIndex(
      partner => partner.self_declared_legal_representative
    )

    this.selectedRepresentative = index !== -1 ? index : 0
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "self-declared-legal-representative":  "Representante principal",
      "self-declared-legal-representative-placeholder": "Nome do representante legal {number}",
      "confirmation-checkbox": "Eu confirmo que a pessoa informada é a representante legal da empresa."
    },
    "en-US": {
      "self-declared-legal-representative":   "Main representative",
      "self-declared-legal-representative-placeholder": "Legal representative name {number}",
      "confirmation-checkbox": "I confirm that the person informed is the legal representative of the company."
    }
  }
</i18n>
